import { useContext } from 'react';
import { FormModalContext } from 'contexts/index';
import { GlobalState } from 'types/globalState';

const useGlobalState = () => useContext<GlobalState>(FormModalContext);
export default useGlobalState;
